import { render, staticRenderFns } from "./TouchpointInfo.vue?vue&type=template&id=35dc4017&scoped=true&"
import script from "./TouchpointInfo.vue?vue&type=script&lang=js&"
export * from "./TouchpointInfo.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointInfo.vue?vue&type=style&index=0&id=35dc4017&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dc4017",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35dc4017')) {
      api.createRecord('35dc4017', component.options)
    } else {
      api.reload('35dc4017', component.options)
    }
    module.hot.accept("./TouchpointInfo.vue?vue&type=template&id=35dc4017&scoped=true&", function () {
      api.rerender('35dc4017', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Statistics/TouchpointInfo/TouchpointInfo.vue"
export default component.exports